export default function Photos() {
    return (
        <div>
            <h1>L'équipe du mariage</h1>
            <p>Ici, vous trouverez bientôt les photos de l'équipe du mariage ! <br/>
            Encore un peu de patience avant que l'on vous révèle cela.</p>

            <p>A noter que pour le jour J, il ne faudra pas courir derrière les mariés pour leur poser des questions.</p>
        </div>
    );
}

